import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=80ac9512&scoped=true"
import script from "./Favorite.vue?vue&type=script&lang=js"
export * from "./Favorite.vue?vue&type=script&lang=js"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=80ac9512&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ac9512",
  null
  
)

export default component.exports